const rankingItems = [
  { rank: 1, title: '流浪地球3', meta: '科幻 · 9.2分', trend: 'up', hot: '🔥 本周最热' },
  { rank: 2, title: '黑暗荣耀 第二季', meta: '韩剧 · 9.0分', trend: 'up', hot: '📈 热度攀升' },
  { rank: 3, title: '封神第二部', meta: '奇幻 · 8.8分', trend: 'up', hot: '🆕 新晋上榜' },
  { rank: 4, title: '鬼灭之刃 最终季', meta: '动漫 · 9.1分', trend: 'same', hot: '' },
  { rank: 5, title: '漫长的季节', meta: '悬疑 · 9.3分', trend: 'up', hot: '' },
  { rank: 6, title: '奥本海默', meta: '传记 · 8.9分', trend: 'down', hot: '' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="text-foreground-600 text-sm mt-2">实时更新全网热播排名，看看大家都在追什么</p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-sm font-bold text-foreground-900">{item.title}</h3>
                  {item.hot && (
                    <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.hot}</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.meta}</p>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-accent-600' :
                  item.trend === 'down' ? 'text-foreground-400' :
                  'text-foreground-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line mr-0.5"></i>}
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-play-circle-line text-lg"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}